import React, {  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,} from "react";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables";
import displayToastMessage from "../../Common/Alert/displayToastMessage";
import { Formik } from "formik";
import { Select } from "@appkit4/react-components/select";
import * as Yup from "yup";
import { forwardRef } from "react";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import { handleNotificationSubmit } from "../notification/notification";
// import MaterialTable from "material-table";
// import AddBox from "@material-ui/icons/AddBox";
// import ArrowDownward from "@material-ui/icons/ArrowDownward";
// import Check from "@material-ui/icons/Check";
// import ChevronLeft from "@material-ui/icons/ChevronLeft";
// import ChevronRight from "@material-ui/icons/ChevronRight";
// import Clear from "@material-ui/icons/Clear";
// import DeleteOutline from "@material-ui/icons/DeleteOutline";
// import Edit from "@material-ui/icons/Edit";
// import FilterList from "@material-ui/icons/FilterList";
// import FirstPage from "@material-ui/icons/FirstPage";
// import LastPage from "@material-ui/icons/LastPage";
// import Remove from "@material-ui/icons/Remove";
// import SaveAlt from "@material-ui/icons/SaveAlt";
// import Search from "@material-ui/icons/Search";
// import ViewColumn from "@material-ui/icons/ViewColumn";
import PropTypes from "prop-types";
// import TextField from "@material-ui/core/TextField";
import useHttp from "../../../hooks/useHttp";
import APIService from "../../../services/apiAxiosService";
import { Loading } from '@appkit4/react-components/loading';


export default function CreateOnSiteAssessment(props) {
  const {
    Assessmentdata,
    categoryData,
    tableDataProp,
    getSelfAssessmentsforAssessor,
    workprogram_id,
    wpID,
    initiateLoader
  } = props;
  
  // const tableIcons = {
  //   Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  //   Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  //   Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  //   Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  //   DetailPanel: forwardRef((props, ref) => (
  //     <ChevronRight {...props} ref={ref} />
  //   )),
  //   Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  //   Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  //   Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  //   FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  //   LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  //   NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  //   PreviousPage: forwardRef((props, ref) => (
  //     <ChevronLeft {...props} ref={ref} />
  //   )),
  //   ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  //   Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  //   SortArrow: forwardRef((props, ref) => (
  //     <ArrowDownward {...props} ref={ref} />
  //   )),
  //   ThirdStateCheck: forwardRef((props, ref) => (
  //     <Remove {...props} ref={ref} />
  //   )),
  //   ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  // };

  const [manager, setManager] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [vendorManager, setVendorManager] = useState([]);
  const [tableData, setTableData] = useState(
    JSON.parse(Assessmentdata[0].asscategory_data)
  );
  const [selectedType, setSelectedType] = useState(1);
  const [workProgramName, setWorkProgramName] = useState([]);
  const [wpDetails, setWPDetails] = useState([]);
  const [selectedTemplateTable, setSelectedTemplateTable] = useState([]);
  const { sendRequest: downloadAPI } = useHttp();
  const { sendRequest: getAllControlWorkProgramAPI } = useHttp();
  const { sendRequest: getAllVendorList } = useHttp();
  const { sendRequest: getWorkProgramDetailsById } = useHttp();
  const { sendRequest: getExcelTableDate } = useHttp();
  const { sendRequest: handleNotificationSubmitAPI } = useHttp();
  const { sendRequest: initiateSelfAssessment } = useHttp();
  const { sendRequest: initiateOnsiteAssessment } = useHttp();
  const { sendRequest: getVendors } = useHttp();
  const { sendRequest: getAllManagersList } = useHttp();
  const [gridApi, setGridApi] = useState(null);
  const [loader, setLoader] = useState(true);



  
  

  // Apply settings across all columns
  const defaultColDef = useMemo(() => ({
    // Enable filtering on all columns,
    // flex:1,
    sortable: true,
    cellDataType: false,
    wrapText: true,     
    autoHeight: true,  
  }));

 

  let getInitialDataHandler = async () => {
    getAllVendorList(
      APIService.getAllVendorList(),
      (result) => {
        if (result.CODE) {
          setVendors(result.MSG);
        }
      },
      (err) => {
        displayToastMessage("Something went wrong, Please try again!", "error");
      }
    );
    getVendors(
      APIService.getVendors(),
      (result) => {
        if (result.CODE) {
          setVendorManager(result.MSG);
        }
      },
      errorHandler
    );

    getAllManagersList(
      APIService.getAllManagersList(),
      (result) => {
        if (result.CODE) {
          setManager(result.MSG);
          setLoader(false);

        }
      },
      errorHandler
    );
  };

  const getWorkPrograms = async () => {
    await getAllControlWorkProgramAPI(
      APIService.getAllControlWorkProgram(),
      (data) => setWorkProgramName(data.MSG)
    );
  };
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  useEffect(() => {
    setTableData(JSON.parse(Assessmentdata[0].asscategory_data))
    let tableData = categoryData;
    let tableType = Object.keys(tableData[0]);
    let type = tableType.includes("Question Id");
    if (type) {
      setSelectedType(2);
    } else {
      setSelectedType(1);
    }

    getInitialDataHandler();
    getWorkPrograms();
  }, []);

  
  //vendorrespondant
  const InitialValues = {
    vendorName: Assessmentdata && Assessmentdata[0].vendor_id,
    scopeOfAssessment: Assessmentdata
      ? Assessmentdata && Assessmentdata[0].scopeofassessment
      : "",
    manager: Assessmentdata && Assessmentdata[0].manager_id,
    respondent: Assessmentdata
      ? Assessmentdata && Assessmentdata[0].vendorrespondant
      : "",
    workProgram: Assessmentdata && Number(Assessmentdata[0].workprogramname),
    workProgramRequestID: Number(wpID),
  };

  const [colDefs1] = useState(
    [
      {
        headerName: "Domain",
        field: "Domain",
      }, {
        headerName: "Sub Domain",
        field: "Sub Domain",
      },  {
        headerName: "Control ID",
        field: "Control ID",
        
      }, {
        headerName: "Control Definition",
        field: "Control Definition",
      }, {
        headerName: "Control Testing Procedure",
        field: "Control Testing Procedure",
      },
    ])
    const [colDefs2] = useState(
    [
    {
      headerName: "Area",
      field: "Area",
    },
    { headerName: "Sub Area", field: "Sub Area" },
    { headerName: "Question Id", field: "Question Id" },
    { headerName: "Question",field: "Question",flex: 1,minWidth: 400,maxWidth: 955},
    { headerName: "Instructions (If any)",field: "Instructions (If any)",flex: 1, minWidth:400, maxWidth:500 },
      { headerName: "Attachment required",field: "Attachment required" },
      { headerName: "Attachment Type",field: "Attachment Type",width:400  },
  ]);


  
  



  const validationSchema = Yup.object().shape({
    vendorName: Yup.string()
      .required("Third party name is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    scopeOfAssessment: Yup.string()
      .required("Scope of assessment is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ).nullable(),
    workProgram: Yup.number().required("Work program is required"),
    manager: Yup.string()
      .required(" Third party manager is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    respondent: Yup.string()
      .required("Third party respondent is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ).nullable(),
  });

  const getWPDetails = async (e) => {
    getWorkProgramDetailsById(
      APIService.getWorkProgramDetailsById(e, 0),
      (result) => {
        if (result.CODE) {
          setWPDetails(result.MSG[0]);
          selectedTemplates(
            JSON.parse(result.MSG[0].filename),
            result.MSG[0].workprogramcategory
          );
        }
      }
    );
  };

  const errorHandler = () => {
    let MSG = "Something went wrong, Please try again!";
    displayToastMessage(MSG, "error");
  };

  const selectedTemplates = async (files, workProgramType) => {
    let fileNames = [[files], workProgramType];
    getExcelTableDate(
      APIService.getExcelTableDate(fileNames),
      (result) => {
        if (result.CODE) {
          let data;

          if (workProgramType === 1) {
            data = [...result.MSG];

            data.forEach((item) => {
              item.domainToggle = true;
              item.subDomainToggle = true;
              item.controlIDToggle = true;
            });
          } else {
            data = [...result.MSG];

            data.forEach((item) => {
              item.areaToggle = true;
              item.subAreaToggle = true;
              item.questionIDToggle = true;
            });
          }

          setSelectedTemplateTable(result.MSG);
          setTableData(result.MSG);
        }
      },
      errorHandler
    );
  };

  function formatDate(date) {
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [ day,month,year].join("-");
  }

  const handleSubmit = async (values) => {
    let jsonArray = [];
    let dataTableValues = categoryData;
    let data = {
      email:sessionStorage.getItem("email"),
      orgName:sessionStorage.getItem("org_name"),
      vendorname:Assessmentdata[0].vendor_name,
      vendorEmail:Assessmentdata[0].vendorpointof_contact_email,
      createddate:formatDate(Assessmentdata[0]?.createddate),
      flag:
        (Assessmentdata &&
          Assessmentdata[0].assessmenttypeid == 4 &&
          Assessmentdata[0].vendor_review_status === "Reviewed/Approved" &&
          Assessmentdata[0].vendor_response_status === "Completed") ||
        (Assessmentdata &&
          Assessmentdata[0].assessmenttypeid == 2 &&
          Assessmentdata[0].vendor_response_status === "Pending" &&
          Assessmentdata[0].vendor_review_status === "Initiated") ||
        (Assessmentdata &&
          Assessmentdata[0].assessmenttypeid == 3 &&
          Assessmentdata[0].vendor_response_status === "Pending" &&
          Assessmentdata[0].vendor_review_status === "Initiated") ||
        (Assessmentdata &&
          Assessmentdata[0].assessmenttypeid == 3 &&
          Assessmentdata[0].vendor_response_status === "Completed" &&
          Assessmentdata[0].vendor_review_status === "Conducted") ||
        (Assessmentdata &&
          Assessmentdata[0].assessmenttypeid == 4 &&
          Assessmentdata[0].vendor_response_status === "Completed" &&
          Assessmentdata[0].vendor_review_status === "Conducted") ||
        (Assessmentdata &&
          Assessmentdata[0].assessmenttypeid == 4 &&
          Assessmentdata[0].vendor_review_status === "Initiated" &&
          Assessmentdata[0].vendor_response_status === "Pending")
          ? "update"
          : "create",
      paramVendorID: Number(values.vendorName),
      paramScopeOfAssessment: values.scopeOfAssessment,
      paramVendorManager: values.manager,
      paramAssessmentTypeID:
        Assessmentdata[0]?.assessmenttypeid,
      paramVendorRespondant: values.respondent,
      paramWorkProgramID: values.workProgram,
      paramWorkProgramRequestID: InitialValues.workProgramRequestID,
      paramAssessmentID:
        Assessmentdata && Assessmentdata[0].assessment_id == null
          ? null
          : Assessmentdata && Assessmentdata[0].assessment_id,
      paramCategoryData:
        Assessmentdata &&
        Assessmentdata[0].vendor_response_status === "Completed"
          ? JSON.stringify(tableData)
          : JSON.stringify(dataTableValues),
      paramUserID: Number(sessionStorage.getItem("userId")),
      paramVendorResponseStatusId:
        Assessmentdata &&
        Assessmentdata[0].assessmenttypeid == 4 &&
        Assessmentdata[0].vendor_review_status === "Reviewed/Approved" &&
        Assessmentdata[0].vendor_response_status === "Completed"
          ? 4
          : "2",
      paramVendorReviewStatusId:
        Assessmentdata &&
        Assessmentdata[0].assessmenttypeid == 4 &&
        Assessmentdata[0].vendor_review_status === "Reviewed/Approved" &&
        Assessmentdata[0].vendor_response_status === "Completed"
          ? 4
          : "2",
      paramAssessmentStatus:
        (Assessmentdata &&
          Assessmentdata[0].assessmenttypeid == 4 &&
          Assessmentdata[0].vendor_review_status === "Reviewed/Approved" &&
          Assessmentdata[0].vendor_response_status === "Completed") ||
        (Assessmentdata &&
          Assessmentdata[0].assessmenttypeid == 2 &&
          Assessmentdata[0].vendor_response_status === "Pending" &&
          Assessmentdata[0].vendor_review_status === "Initiated") ||
        (Assessmentdata &&
          Assessmentdata[0].assessmenttypeid == 3 &&
          Assessmentdata[0].vendor_response_status === "Pending" &&
          Assessmentdata[0].vendor_review_status === "Initiated") ||
        (Assessmentdata &&
          Assessmentdata[0].assessmenttypeid == 4 &&
          Assessmentdata[0].vendor_review_status === "Initiated" &&
          Assessmentdata[0].vendor_response_status === "Pending")
          ? "Updated"
          : "Created",
    };

    jsonArray.push(data);
    if (
      (Assessmentdata &&
        Assessmentdata[0].assessmenttypeid == 4 &&
        Assessmentdata[0].vendor_response_status == null &&
        Assessmentdata[0].vendor_review_status == null) ||
      (Assessmentdata &&
        Assessmentdata[0].assessmenttypeid == 4 &&
        Assessmentdata[0].vendor_review_status === "Initiated" &&
        Assessmentdata[0].vendor_response_status === "Pending")
    ) {
      initiateSelfAssessment(
        APIService.initiateSelfAssessment(jsonArray),
        (result) => {
          if (result.CODE) {
            displayToastMessage(result.MSG, "success");
            let notifData = {
              paramuserid: Number(sessionStorage.getItem("userId")),
              paramreqid: Assessmentdata[0]?.vendor_user_id,
              paramcontent: "Initiated self assessment",
              paramnextroleid: 5,
              paramcreatedby: Number(sessionStorage.getItem("roleId")),
              parammsgtype: result.MSG,
            };
            handleNotificationSubmitAPI(
              APIService.handleNotificationSubmit(notifData),
              () => {}
            );
            props.handleBack();
            getSelfAssessmentsforAssessor();
          }
        },
        errorHandler
      );
    } else if (
      (Assessmentdata &&
        Assessmentdata[0].assessmenttypeid == 3 &&
        Assessmentdata[0].vendor_response_status == null &&
        Assessmentdata[0].vendor_review_status == null) ||
      (Assessmentdata &&
        Assessmentdata[0].assessmenttypeid == 3 &&
        Assessmentdata[0].vendor_response_status === "Pending" &&
        Assessmentdata[0].vendor_review_status === "Initiated")
    ) {
      initiateOnsiteAssessment(
        APIService.initiateOnsiteAssessment(jsonArray),
        (result) => {
          if (result.CODE) {
            let notifData = {
              paramuserid: Number(sessionStorage.getItem("userId")),
              paramreqid: Number(values.vendorName),
              paramcontent: "Initiated on-site assessment",
              paramnextroleid: 5,
              paramcreatedby: Number(sessionStorage.getItem("roleId")),
              parammsgtype: result.MSG,
            };
            handleNotificationSubmitAPI(
              APIService.handleNotificationSubmit(notifData),
              () => {}
            );
            displayToastMessage(result.MSG, "success");
            props.handleBack();
            getSelfAssessmentsforAssessor();
          }
        },
        errorHandler
      );
    } else if (
      (Assessmentdata &&
        Assessmentdata[0].assessmenttypeid == 2 &&
        Assessmentdata[0].vendor_response_status == null &&
        Assessmentdata[0].vendor_review_status == null) ||
      (Assessmentdata &&
        Assessmentdata[0].assessmenttypeid == 2 &&
        Assessmentdata[0].vendor_response_status === "Pending" &&
        Assessmentdata[0].vendor_review_status === "Initiated")
    ) {
      initiateSelfAssessment(
        APIService.initiateSelfAssessment(jsonArray),
        (result) => {
          if (result.CODE) {
            displayToastMessage(result.MSG, "success");
            let notifData = {
              paramuserid: Number(sessionStorage.getItem("userId")),
              paramreqid: Assessmentdata && Assessmentdata[0].vendor_user_id,
              paramcontent: "Initiated self assessment",
              paramnextroleid: 5,
              paramcreatedby: Number(sessionStorage.getItem("roleId")),
              parammsgtype: result.MSG,
            };
            handleNotificationSubmitAPI(
              APIService.handleNotificationSubmit(notifData),
              () => {}
            );
            props.handleBack();
            getSelfAssessmentsforAssessor();
          }
        },
        errorHandler
      );
    } else {
      initiateOnsiteAssessment(
        APIService.initiateOnsiteAssessment(jsonArray),
        (result) => {
          if (result.CODE) {
            let notifData = {
              paramuserid: Number(sessionStorage.getItem("userId")),
              paramreqid: Number(values.vendorName),
              paramcontent: "Initiated on-site assessment",
              paramnextroleid: 5,
              paramcreatedby: Number(sessionStorage.getItem("roleId")),
              parammsgtype: result.MSG,
            };
            handleNotificationSubmitAPI(
              APIService.handleNotificationSubmit(notifData),
              () => {}
            );
            displayToastMessage(result.MSG, "success");
            props.handleBack();
            // getSelfAssessmentsforAssessor()
          }
        },
        errorHandler
      );
    }
    getSelfAssessmentsforAssessor();
  };

  const downloadResponseHandler = (result, data, fileName) => {
    if (result) {
      const blob = new Blob([result?.data], {
        type: "application/octet-stream",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", data, fileName);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      displayToastMessage("File Downloaded successfully", "success");
    }
  };

  const getDownloadFile = async (data, fileName) => {
    await downloadAPI(
      APIService.downloadFile(data),
      (res) => downloadResponseHandler(res, data, fileName),
      (err) => {
        console.log("Error", err);
        let MSG = "Something went wrong, Please try again!";
        displayToastMessage(MSG, "error");
      },
      true
    );
  };
  const rowStyle = { background: 'white' };


  return (
    <div className="App">
      <div className="row text-end pt-3">
        <div className="col-md-12">
          <span
            className="Appkit4-icon icon-arrow-left-outline pointer back-fill"
            onClick={props.handleBack}
          ></span>
        </div>
      </div>
      <Formik
        initialValues={InitialValues}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        enableReinitialize={true}
      >
        {(prop) => {
          const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          } = prop;
          return (
            
            loader ?(
                  <div className="row" id="preloader">
                  <div className="col-12 col-lg-12 loader-margin text-center loadingCss">
                    <div className="a-loading a-primary a-m-10 loadingText" role="status">
                     Loading...
                     <Loading loadingType='circular' indeterminate={true} compact={false}></Loading>
                    </div>
                  </div>
                </div>
                )
          :
            <form onSubmit={handleSubmit}>
              <div className="row mt-3">
                <div className="col-sm-6">
                  <div className="cv-input-field-container pt-0 pb-0">
                    <label className="cv-input-label">
                      Third Party Name <span className="asterisk-required">*</span>
                    </label>
                    <Select
                      className="cv-input-field"
                      dropdownRenderMode="portal"
                      type="email"
                      data={vendors}
                      valueKey="vendor_id"
                      labelKey="vendor_name"
                      value={values.vendorName}
                      dropdownAlwaysDown={false}
                      name="assessment"
                      placeholder="Select Third Party Name"
                      disabled
                    ></Select>
                  </div>
                  {errors.vendorName && touched.vendorName && (
                    <div className="form-label error">{errors.vendorName}</div>
                  )}
                </div>
                <div className="col-sm-6">
                  <div className="cv-input-field-container pt-0 pb-0">
                    <label htmlFor="scopeCreate" className="cv-input-label">
                      Scope Of Assessment <span className="asterisk-required">*</span>
                    </label>
                    <input
                      className="cv-input-field"
                      onBlur={handleBlur}
                      id="scopeCreate"
                      type="text"
                      value={values.scopeOfAssessment}
                      onChange={handleChange("scopeOfAssessment")}
                      name="scope Of Assessment"
                      placeholder="Please enter scope of assessment"
                    />
                  </div>
                  {errors.scopeOfAssessment && touched.scopeOfAssessment && (
                    <div className="form-label error">
                      {errors.scopeOfAssessment}
                    </div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="cv-input-field-container pt-0 pb-0">
                    <label className="cv-input-label">
                      Third Party Manager <span className="asterisk-required">*</span>
                    </label>
                    <Select
                      className="cv-input-field"
                      dropdownRenderMode="portal"
                      type="email"
                      data={manager}
                      valueKey="user_id"
                      labelKey="user_name"
                      value={values.manager}
                      dropdownAlwaysDown={false}
                      onSelect={(e) =>
                        handleChange("manager")({ target: { value: e } })
                      }
                      name="assessment"
                      placeholder="Select Manager"
                      disabled
                    ></Select>
                  </div>
                  {errors.manager && touched.manager && (
                    <div className="form-label error">{errors.manager}</div>
                  )}
                </div>
                <div className="col-sm-6">
                  <div className="cv-input-field-container pt-0 pb-0">
                    <label htmlFor="respondentCreate" className="cv-input-label">
                      Third Party Respondent <span className="asterisk-required">*</span>
                    </label>
                    <input
                      className="cv-input-field"
                      onBlur={handleBlur}
                      id="respondentCreate"
                      type="text"
                      value={values.respondent}
                      onChange={handleChange("respondent")}
                      name="respondent"
                      placeholder="Please enter third party respondent"
                    />
                  </div>
                  {errors.respondent && touched.respondent && (
                        <div className="form-label error">
                          {errors.respondent}
                        </div>
                      )}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="cv-input-field-container pt-0 pb-0">
                    <label className="cv-input-label">
                      Work Program Name <span className="asterisk-required">*</span>
                    </label>
                    <Select
                      showSearchOnToggle={true}
                      dropdownRenderMode="portal"
                      className="cv-input-field"
                      value={values.workProgram}
                      data={workProgramName}
                      dropdownAlwaysDown={false}
                      labelKey="work_program_name"
                      valueKey="workprogram_id"
                      name="Third Party Name"
                      placeholder="Select work program Name"
                      disabled
                    ></Select>
                  </div>
                  {errors.workProgramName && touched.workProgramName && (
                    <div className="form-label error">
                      {errors.workProgramName}
                    </div>
                  )}
                </div>
              </div>
              <div className="row pt-5 pl-3">
                <div className="col-lg-12 mt-3 pl-1">
                  {((Assessmentdata &&
                    Assessmentdata[0].assessmenttypeid == 4 &&
                    Assessmentdata[0].vendor_response_status == null &&
                    Assessmentdata[0].vendor_review_status == null) ||
                    (Assessmentdata &&
                      Assessmentdata[0].assessmenttypeid == 4 &&
                      Assessmentdata[0].vendor_review_status === "Initiated" &&
                      Assessmentdata[0].vendor_response_status ===
                        "Pending")) && (
                          <div class="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
                          <AgGridReact
                            rowData={Assessmentdata && categoryData}
                            columnDefs={ selectedType === 1?colDefs1:colDefs2}
                            defaultColDef={defaultColDef}
                            pagination={true}
                            onGridReady={onGridReady}
                            rowStyle={rowStyle}

                          />
                        </div> )}
        { (Assessmentdata &&Assessmentdata[0].assessmenttypeid == 2 && Assessmentdata[0].vendor_response_status== null && Assessmentdata[0].vendor_review_status== null  ||
          Assessmentdata &&Assessmentdata[0].assessmenttypeid == 2 && Assessmentdata[0].vendor_response_status==="Pending" && Assessmentdata[0].vendor_review_status==="Initiated") &&       
         ( <div class="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
         <AgGridReact
           rowData={Assessmentdata && categoryData}
           columnDefs={ selectedType === 1?colDefs1:colDefs2}
           defaultColDef={defaultColDef}
           pagination={true}
           onGridReady={onGridReady}
         
         />
       </div>)
         }
                  
        {/* { (Assessmentdata && Assessmentdata[0].assessmenttypeid == 4 && Assessmentdata[0].vendor_review_status==="Reviewed/Approved" && Assessmentdata[0].vendor_response_status==="Completed")&&
                      <MaterialTable
                      icons={tableIcons}
                      title="Work Program"
                      data={Assessmentdata && categoryData}
                      columns={
                        selectedType === 1
                          ? [
                            // {
                            //   title: "S.No",
                            //   field: "S.No",
                            //   cellStyle: {
                            //     whiteSpace: "nowrap",
                            //     textAlign: "center",
                            //   },
                            // },
  
                            { title: "Domain", field: "Domain",editable: 'never', },
                            // {
                            //   title: "S.No",
                            //   field: "S.No Sub Domain",
                            //   cellStyle: {
                            //     whiteSpace: "nowrap",
                            //     textAlign: "center",
                            //   },
                            // },
                            { title: "Sub Domain", field: "Sub Domain",editable: 'never', },
                            // {
                            //   title: "Control ID",
                            //   field: "Control ID",
                            //   cellStyle: {
                            //     whiteSpace: "nowrap",
                            //     textAlign: "center",
                            //   },
                            // },
                            {
                              title: "Control Definition",
                              field: "Control Definition",
                              editable: 'never',
                            },
                            {
                              title: "Control Testing Procedure",
                              field: "Control Testing Procedure",
                              editable: 'never',
                            },
  
                            {
                              title: "Third Party Responses",
                              field: "Vendor Response",
                              editable: 'never',
                              cellStyle: {
                                width: 400,
                                minWidth:400,
                                whiteSpace: 'pre-wrap' 
                                },
                                headerStyle: {
                                width: 400,
                                minWidth:400
                                },
                             
                            },
                            {
                              title: "Evidence",
                              field: "Evidence",
                              editable: 'never',
                              cellRenderer: (rowData) => {
                                if(rowData?.data?.Evidence_File_Content)
                                {
                                  return rowData?.data?.Evidence ?
                                  (rowData?.data?.Evidence_File_Content ?
                                    (
                                      <a href={rowData?.data?.Evidence_File_Content} download={rowData?.data?.Evidence} className="hyperText">{rowData?.data?.Evidence}</a>
                                    )
                                    : (<>{rowData?.data?.Evidence}</>))
                                  : (<p>No file Attachment</p>)
                                }else{
                                 return rowData?.data?.Evidence ?
                                  (rowData?.data?.Evidence_File_Path ?
                                    (
                                      <div onClick={()=>getDownloadFile(rowData?.data?.Evidence_File_Path,rowData?.data?.Evidence)} className="hyperText">{rowData?.data?.Evidence} </div>
                                    )
                                    : (<>{rowData?.data?.Evidence}</>))
                                  : (<p>No file Attachment</p>)
                                    }
                              },
  
                              
                            },
  
                            {
                              title: "Assessor Comments",
                              field: "Assessor Comments",
                              cellStyle: {
                                width: 250,
                                minWidth:250,
                                whiteSpace: 'pre-wrap' 
                                },
                                headerStyle: {
                                width: 250,
                                minWidth:250
                                },
                              editComponent: props => (
                                <TextField
                                    value={props.value}
                              fullWidth={true}
                              multiline={true}
                              onChange={e => props.onChange(e.target.value)}
                              error={props.value&& props.value.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1}
helperText={props.value&& props.value.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1 ? 'Allowed special characters .:/,()' : ''}
                                />
                            )
                             
                            },
                            {
                              title: "Closure Status",
                              field: "Closure Status",
                              lookup: {gap: "Gap Identified", noGap: "No Gap Identified"}
                            },
                          ]
                          : [
                            { title: "Area", field: "Area",editable: 'never', },
                            {
                              title: "Sub Area",
                              field: "Sub Area",
                            },
                            { title: "Question Id", field: "Question Id", editable: 'never' },
                            { title: "Question", field: "Question",editable: 'never',cellStyle: {
                              width: 300,
                              minWidth:300,
                              whiteSpace:"pre-wrap"
                              },
                              headerStyle: {
                              width: 300,
                              minWidth:300
                              } },
                            {
                              title: "Instructions (If any)",
                              field: "Instructions (If any)",
                              editable: 'never',cellStyle: {
                                width: 300,
                                minWidth:300,
                                whiteSpace:"pre-wrap"
                                },
                                headerStyle: {
                                width: 300,
                                minWidth:300
                                }
                            },
                            {
                              title: "Third Party Responses",
                              field: "Vendor Response",
                              editable: 'never',
                              cellStyle: {
                                width: 400,
                                minWidth:400,
                                whiteSpace: 'pre-wrap' 
                                },
                                headerStyle: {
                                width: 400,
                                minWidth:400
                                },
                              
                            },
                            {
                              title: "Evidence",
                              field: "Evidence",
                              editable: 'never',
                              render: (rowData) => {
                                if(rowData?.data?.Evidence_File_Content)
                                {
                                  return rowData?.data?.Evidence ?
                                  (rowData?.data?.Evidence_File_Content ?
                                    (
                                      <a href={rowData?.data?.Evidence_File_Content} download={rowData?.data?.Evidence} className="hyperText">{rowData?.data?.Evidence}</a>
                                    )
                                    : (<>{rowData?.data?.Evidence}</>))
                                  : (<p>No file Attachment</p>)
                                }else{
                                 return rowData?.data?.Evidence ?
                                  (rowData?.data?.Evidence_File_Path ?
                                    (
                                      <div onClick={()=>getDownloadFile(rowData?.data?.Evidence_File_Path,rowData?.data?.Evidence)} className="hyperText">{rowData?.data?.Evidence} </div>
                                    )
                                    : (<>{rowData?.data?.Evidence}</>))
                                  : (<p>No file Attachment</p>)
                                    }
                              },
  
                              
                            },
                            {
                              title: " Assessor Comments",
                              field: "Assessor Comments",
                              cellStyle: {
                                width: 250,
                                minWidth:250,
                                whiteSpace: 'pre-wrap' 
                                },
                                headerStyle: {
                                width: 250,
                                minWidth:250
                                },
                              editComponent: props => (
                                <TextField
                                    value={props.value}
                              fullWidth={true}
                              multiline={true}
                              onChange={e => props.onChange(e.target.value)}
                              error={props.value&& props.value.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1}
helperText={props.value&& props.value.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1 ? 'Allowed special characters .:/,()' : ''}
                                />
                            )
                            },
                            {
                              title: "Closure Status",
                              field: "Closure Status",
                              lookup: {gap: "Gap Identified", noGap: "No Gap Identified"}
                            },
                          ]
                      }
                      editable={{
                        onRowUpdate: (newData, oldData) =>
                        new Promise((resolve, reject) => {
                          if(newData["Assessor Comments"].search(/[^()0-9a-zA-Z,.:/ ]/) !== -1)

                          {
                            displayToastMessage("Something went wrong, Please try again!", "error");
                            reject();
                          }else{
                          setTimeout(() => {
                            const dataUpdate = [...tableData];
                            const index = oldData.tableData.id;
                            dataUpdate[index] = newData;
                            setTableData([...dataUpdate]);
                            resolve();
                          }, 1000);
                        }
                        }),
                      }}
                      options={{
                        actionsColumnIndex: -1,
                        headerStyle: {
                          backgroundColor: "#F2F2F2",
                          borderTop: "1px solid #C5C5c5",
                          color: "Black",
                          whiteSpace: "nowrap",
                        },
                      }}
                    />
                  } */}

                  {((Assessmentdata &&
                    Assessmentdata[0].assessmenttypeid == 3 &&
                    Assessmentdata[0].vendor_response_status == null &&
                    Assessmentdata[0].vendor_review_status == null) ||
                    (Assessmentdata && 
                      Assessmentdata[0].assessmenttypeid == 3 &&
                      Assessmentdata[0].vendor_response_status === "Pending" &&
                      Assessmentdata[0].vendor_review_status ===
                        "Initiated")) && (
                          <div class="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
                          <AgGridReact
                            rowData={Assessmentdata && categoryData}
                            columnDefs={ selectedType === 1?colDefs1:colDefs2}
                            defaultColDef={defaultColDef}
                            pagination={true}
                            onGridReady={onGridReady}
                          
                          />
                        </div>
                  )}
                  {/* {Assessmentdata &&
                    Assessmentdata[0].assessmenttypeid == 4 &&
                    Assessmentdata[0].vendor_review_status ===
                      "Reviewed/Approved" &&
                    Assessmentdata[0].vendor_response_status ===
                      "Completed" && (
                      <MaterialTable
                        icons={tableIcons}
                        title="Work Program"
                        data={tableData && tableData}
                        columns={
                          selectedType === 1
                            ? [
                                // {
                                //   title: "S.No",
                                //   field: "S.No",
                                //   cellStyle: {
                                //     whiteSpace: "nowrap",
                                //     textAlign: "center",
                                //   },
                                // },

                                {
                                  title: "Domain",
                                  field: "Domain",
                                  editable: "never",
                                },
                                // {
                                //   title: "S.No",
                                //   field: "S.No Sub Domain",
                                //   cellStyle: {
                                //     whiteSpace: "nowrap",
                                //     textAlign: "center",
                                //   },
                                // },
                                {
                                  title: "Sub Domain",
                                  field: "Sub Domain",
                                  editable: "never",
                                },
                                // {
                                //   title: "Control ID",
                                //   field: "Control ID",
                                //   cellStyle: {
                                //     whiteSpace: "nowrap",
                                //     textAlign: "center",
                                //   },
                                // },
                                {
                                  title: "Control Definition",
                                  field: "Control Definition",
                                  editable: "never",
                                },
                                {
                                  title: "Control Testing Procedure",
                                  field: "Control Testing Procedure",
                                  editable: "never",
                                },

                                {
                                  title: "Third Party Responses",
                                  field: "Vendor Response",
                                  editable: "never",
                                },
                                {
                                  title: "Evidence",
                                  field: "Evidence",
                                  editable: "never",
                                  render: (rowData) => {
                                    return rowData?.Evidence ? (
                                      rowData?.Evidence_File_Path ? (
                                        <div
                                          onClick={() =>
                                            getDownloadFile(
                                              rowData?.Evidence_File_Path,
                                              rowData?.Evidence
                                            )
                                          }
                                          className="hyperText"
                                        >
                                          {rowData?.Evidence}{" "}
                                        </div>
                                      ) : (
                                        <>{rowData?.Evidence}</>
                                      )
                                    ) : (
                                      <p>No file Attachment</p>
                                    );
                                  },
                                },

                                {
                                  title: "Assessor Comments",
                                  field: "Assessor Comments",
                                  cellStyle: {
                                    width: 250,
                                    minWidth:250,
                                    whiteSpace: 'pre-wrap' 
                                    },
                                    headerStyle: {
                                    width: 250,
                                    minWidth:250
                                    },
                                  editComponent: props => (
                                    <TextField
                                        value={props.value}
                                  fullWidth={true}
                                  multiline={true}
                                  onChange={e => props.onChange(e.target.value)}
                                  error={props.value&& props.value.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1}
    helperText={props.value&& props.value.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1 ? 'Allowed special characters .:/,()' : ''}
                                    />
                                  ),
                                },
                                {
                                  title: "Closure Status",
                                  field: "Closure Status",
                                  lookup: {
                                    gap: "Gap Identified",
                                    noGap: "No Gap Identified",
                                  },
                                },
                              ]
                            : [
                                {
                                  title: "Area",
                                  field: "Area",
                                  editable: "never",
                                },
                                {
                                  title: "Sub Area",
                                  field: "Sub Area",
                                },
                                {
                                  title: "Question Id",
                                  field: "Question Id",
                                  editable: "never",
                                   },
                                
                                {
                                  title: "Question",
                                  field: "Question",
                                  editable: "never",
                                  cellStyle: {
                                    width: 300,
                                    minWidth:300,
                                    whiteSpace:"pre-wrap"
                                    },
                                    headerStyle: {
                                    width: 300,
                                    minWidth:300
                                    }
                                },
                                {
                                  title: "Instructions (If any)",
                                  field: "Instructions (If any)",
                                  editable: "never",
                                  cellStyle: {
                                    width: 300,
                                    minWidth:300,
                                    whiteSpace:"pre-wrap"
                                    },
                                    headerStyle: {
                                    width: 300,
                                    minWidth:300
                                    }
                                },
                                {
                                  title: "Third Party Responses",
                                  field: "Vendor Response",
                                  editable: "never",
                                  cellStyle: {
                                    width: 400,
                                    minWidth:400,
                                    whiteSpace: 'pre-wrap' 
                                    },
                                    headerStyle: {
                                    width: 400,
                                    minWidth:400
                                    },
                                },
                                {
                                  title: "Evidence",
                                  field: "Evidence",
                                  editable: "never",
                                  render: (rowData) => {
                                    return rowData?.Evidence ? (
                                      rowData?.Evidence_File_Path ? (
                                        <div
                                          onClick={() =>
                                            getDownloadFile(
                                              rowData?.Evidence_File_Path,
                                              rowData?.Evidence
                                            )
                                          }
                                          className="hyperText"
                                        >
                                          {rowData?.Evidence}{" "}
                                        </div>
                                      ) : (
                                        <>{rowData?.Evidence}</>
                                      )
                                    ) : (
                                      <p>No file Attachment</p>
                                    );
                                  },
                                },
                                {
                                  title: " Assessor Comments",
                                  field: "Assessor Comments" , cellStyle: {
                                    width: 250,
                                    minWidth:250,
                                    whiteSpace: 'pre-wrap' 
                                    },
                                    headerStyle: {
                                    width: 250,
                                    minWidth:250
                                    },
                                  editComponent: props => (
                                    <TextField
                                        value={props.value}
                                  fullWidth={true}
                                  multiline={true}
                                  onChange={e => props.onChange(e.target.value)}
                                  error={props.value&& props.value.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1}
    helperText={props.value&& props.value.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1 ? 'Allowed special characters .:/,()' : ''}
                                    />
                                  ),
                                },
                                {
                                  title: "Closure Status",
                                  field: "Closure Status",
                                  lookup: {
                                    gap: "Gap Identified",
                                    noGap: "No Gap Identified",
                                  },
                                },
                              ]
                        }
                        editable={{
                          onRowUpdate: (newData, oldData) =>
                          new Promise((resolve, reject) => {
                            if(newData["Assessor Comments"].search(/[^()0-9a-zA-Z,.:/ ]/) !== -1)
  
                            {
                              displayToastMessage("Something went wrong, Please try again!", "error");
                              reject();
                            }else{
                            setTimeout(() => {
                              const dataUpdate = [...tableData];
                              const index = oldData.tableData.id;
                              dataUpdate[index] = newData;
                              setTableData([...dataUpdate]);
                              resolve();
                            }, 1000);
                          }
                          }),
                        }}
                        options={{
                          actionsColumnIndex: -1,
                          headerStyle: {
                            backgroundColor: "#F2F2F2",
                            borderTop: "1px solid #C5C5c5",
                            color: "Black",
                            whiteSpace: "nowrap",
                          },
                        }}
                      />
                    )}
                  {Assessmentdata &&
                    Assessmentdata[0].assessmenttypeid == 4 &&
                    Assessmentdata[0].vendor_review_status === "Conducted" &&
                    Assessmentdata[0].vendor_response_status ===
                      "Completed" && (
                      <MaterialTable
                        icons={tableIcons}
                        title="Work Program"
                        data={tableData && tableData}
                        columns={
                          selectedType === 1
                            ? [
                                // {
                                //   title: "S.No",
                                //   field: "S.No",
                                //   cellStyle: {
                                //     whiteSpace: "nowrap",
                                //     textAlign: "center",
                                //   },
                                // },

                                {
                                  title: "Domain",
                                  field: "Domain",
                                  editable: "never",
                                },
                                // {
                                //   title: "S.No",
                                //   field: "S.No Sub Domain",
                                //   cellStyle: {
                                //     whiteSpace: "nowrap",
                                //     textAlign: "center",
                                //   },
                                // },
                                {
                                  title: "Sub Domain",
                                  field: "Sub Domain",
                                  editable: "never",
                                },
                                // {
                                //   title: "Control ID",
                                //   field: "Control ID",
                                //   cellStyle: {
                                //     whiteSpace: "nowrap",
                                //     textAlign: "center",
                                //   },
                                // },
                                {
                                  title: "Control Definition",
                                  field: "Control Definition",
                                  editable: "never",
                                },
                                {
                                  title: "Control Testing Procedure",
                                  field: "Control Testing Procedure",
                                  editable: "never",
                                },

                                {
                                  title: "Third Party Responses",
                                  field: "Vendor Response",
                                  editable: "never",
                                },
                                {
                                  title: "Evidence",
                                  field: "Evidence",
                                  editable: "never",
                                  render: (rowData) => {
                                    return rowData?.Evidence ? (
                                      rowData?.Evidence_File_Path ? (
                                        <div
                                          onClick={() =>
                                            getDownloadFile(
                                              rowData?.Evidence_File_Path,
                                              rowData?.Evidence
                                            )
                                          }
                                          className="hyperText"
                                        >
                                          {rowData?.Evidence}{" "}
                                        </div>
                                      ) : (
                                        <>{rowData?.Evidence}</>
                                      )
                                    ) : (
                                      <p>No file Attachment</p>
                                    );
                                  },
                                },

                                {
                                  title: "Assessor Comments",
                                  field: "Assessor Comments",
                                  cellStyle: {
                                    width: 250,
                                    minWidth:250,
                                    whiteSpace: 'pre-wrap' 
                                    },
                                    headerStyle: {
                                    width: 250,
                                    minWidth:250
                                    },
                                  editComponent: props => (
                                    <TextField
                                        value={props.value}
                                  fullWidth={true}
                                  multiline={true}
                                  onChange={e => props.onChange(e.target.value)}
                                  error={props.value&& props.value.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1}
    helperText={props.value&& props.value.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1 ? 'Allowed special characters .:/,()' : ''}
                                    />
                                  ),
                                },
                                {
                                  title: "Closure Status",
                                  field: "Closure Status",
                                  lookup: {
                                    gap: "Gap Identified",
                                    noGap: "No Gap Identified",
                                  },
                                },
                              ]
                            : [
                                {
                                  title: "Area",
                                  field: "Area",
                                  editable: "never",
                                },
                                {
                                  title: "Sub Area",
                                  field: "Sub Area",
                                },
                                {
                                  title: "Question Id",
                                  field: "Question Id",
                                  editable: "never",
                                },
                                {
                                  title: "Question",
                                  field: "Question",
                                  editable: "never",
                                  cellStyle: {
                                    width: 300,
                                    minWidth:300,
                                    whiteSpace:"pre-wrap"
                                    },
                                    headerStyle: {
                                    width: 300,
                                    minWidth:300
                                    }
                                },
                                {
                                  title: "Instructions (If any)",
                                  field: "Instructions (If any)",
                                  editable: "never",
                                  cellStyle: {
                                    width: 300,
                                    minWidth:300,
                                    whiteSpace:"pre-wrap"
                                    },
                                    headerStyle: {
                                    width: 300,
                                    minWidth:300
                                    }
                                },
                                {
                                  title: "Third Party Responses",
                                  field: "Vendor Response",
                                  editable: "never",
                                  cellStyle: {
                                    width: 400,
                                    minWidth:400,
                                    whiteSpace: 'pre-wrap' 
                                    },
                                    headerStyle: {
                                    width: 400,
                                    minWidth:400
                                    }     
                                },
                                {
                                  title: "Evidence",
                                  field: "Evidence",
                                  editable: "never",
                                  render: (rowData) => {
                                    return rowData?.Evidence ? (
                                      rowData?.Evidence_File_Path ? (
                                        <div
                                          onClick={() =>
                                            getDownloadFile(
                                              rowData?.Evidence_File_Path,
                                              rowData?.Evidence
                                            )
                                          }
                                          className="hyperText"
                                        >
                                          {rowData?.Evidence}{" "}
                                        </div>
                                      ) : (
                                        <>{rowData?.Evidence}</>
                                      )
                                    ) : (
                                      <p>No file Attachment</p>
                                    );
                                  },
                                },
                                {
                                  title: " Assessor Comments",
                                  field: "Assessor Comments",
                                  cellStyle: {
                                    width: 250,
                                    minWidth:250,
                                    whiteSpace: 'pre-wrap' 
                                    },
                                    headerStyle: {
                                    width: 250,
                                    minWidth:250
                                    },
                                  editComponent: props => (
                                    <TextField
                                        value={props.value}
                                  fullWidth={true}
                                  multiline={true}
                                  onChange={e => props.onChange(e.target.value)}
                                  error={props.value&& props.value.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1}
                                  helperText={props.value&& props.value.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1 ? 'Allowed special characters .:/,()' : ''}
                                    />
                                  ),
                                },
                                {
                                  title: "Closure Status",
                                  field: "Closure Status",
                                  lookup: {
                                    gap: "Gap Identified",
                                    noGap: "No Gap Identified",
                                  },
                                },
                              ]
                        }
                        editable={{
                          onRowUpdate: (newData, oldData) =>
                        new Promise((resolve, reject) => {
                          if(newData["Assessor Comments"].search(/[^()0-9a-zA-Z,.:/ ]/) !== -1)

                          {
                            displayToastMessage("Something went wrong, Please try again!", "error");
                            reject();
                          }else{
                          setTimeout(() => {
                            const dataUpdate = [...tableData];
                            const index = oldData.tableData.id;
                            dataUpdate[index] = newData;
                            setTableData([...dataUpdate]);
                            resolve();
                          }, 1000);
                        }
                        }),
                        }}
                        options={{
                          actionsColumnIndex: -1,
                          headerStyle: {
                            backgroundColor: "#F2F2F2",
                            borderTop: "1px solid #C5C5c5",
                            color: "Black",
                            whiteSpace: "nowrap",
                          },
                        }}
                      /> 
                    )}*/}
                </div>
                <div className="options-container">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="save-button mt-4 me-4"
                  >
                    Initiate
                  </button>
                  
                  <button
                    className="cancel-button mt-4 me-3"
                    type="reset"
                    onClick={props.handleBack}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </div>
  );
}

CreateOnSiteAssessment.propTypes = {
  Assessmentdata: PropTypes.any, 
  categoryData: PropTypes.any, 
  getSelfAssessmentsforAssessor: PropTypes.any, 
  wpID: PropTypes.any,
  handleBack: PropTypes.any,
  value: PropTypes.any,
  onChange: PropTypes.any
}